/**
 * Display labels for available temporal resolutions used in the UI.
 * Keys correspond to resolution identifiers and values are the human-readable labels.
 */
export enum TemporalResolutionDisplay {
  'monthly' = 'Monthly',
  'annual-calendar' = 'Annual - Calendar year (January 1 to December 31)',
  'annual-water' = 'Annual - Water year (October 1 to September 30)',
}

/**
 * Production-only display labels for temporal resolutions.
 * This is a reduced set used when running in production mode.
 */
export enum TemporalResolutionDisplayProd {
  'monthly' = 'Monthly',
}

/**
 * Return the appropriate set of temporal resolution display labels based on the current build mode.
 *
 * In production this returns TemporalResolutionDisplayProd (a reduced set). In non-production
 * modes it returns the full TemporalResolutionDisplay.
 *
 * @returns {typeof TemporalResolutionDisplay | typeof TemporalResolutionDisplayProd} the
 *          enum object containing labels for temporal resolutions appropriate for the current mode.
 */
export function getAvailableTemporalResolutions():
  | typeof TemporalResolutionDisplay
  | typeof TemporalResolutionDisplayProd {
  const mode = import.meta.env.MODE;
  return mode === 'production'
    ? TemporalResolutionDisplayProd
    : TemporalResolutionDisplay;
}
